import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { ICardNumberRequest, ICardNumberResponse } from '../models/models'

export class OrderDetailApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/payment/cardNumber',
      requesterInfo,
    })
  }

  public async getOrderDetail(req: ICardNumberRequest): Promise<ICardNumberResponse> {
    return await this.postAsync<ICardNumberResponse>(req)
  }
}
